import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertComponent } from './shared/component/alert-component/alert-component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AlertComponent],
  styleUrls: ['./app.css'],
  template: ` <div>
    <router-outlet />
    <app-alert-component />
  </div>`,
})
export class App {}
